














import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation} from 'vuex-class'
import {Task} from '@/store/types'
import SurveyModel from '@/classes/SurveyModel'

@Component({})
export default class SurveyCompleted extends Vue {
  @Getter('taskCompleted') public taskCompleted!: Task
  @Mutation('unsetCompletedTask') public unsetCompletedTask: any
  public SurveyModel = SurveyModel

  public closeCompletedTask() {
    this.unsetCompletedTask()
  }
}
